"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DayOfWeek = exports.DisabledDateRuleName = void 0;
var DisabledDateRuleName;
exports.DisabledDateRuleName = DisabledDateRuleName;

(function (DisabledDateRuleName) {
  DisabledDateRuleName["AFTER"] = "AFTER";
  DisabledDateRuleName["BEFORE"] = "BEFORE";
  DisabledDateRuleName["BETWEEN"] = "BETWEEN";
  DisabledDateRuleName["IS"] = "IS";
  DisabledDateRuleName["IS_DAY_OF_WEEK"] = "IS_DAY_OF_WEEK";
})(DisabledDateRuleName || (exports.DisabledDateRuleName = DisabledDateRuleName = {}));

var DayOfWeek;
exports.DayOfWeek = DayOfWeek;

(function (DayOfWeek) {
  DayOfWeek[DayOfWeek["SUNDAY"] = 0] = "SUNDAY";
  DayOfWeek[DayOfWeek["MONDAY"] = 1] = "MONDAY";
  DayOfWeek[DayOfWeek["TUESDAY"] = 2] = "TUESDAY";
  DayOfWeek[DayOfWeek["WEDNESDAY"] = 3] = "WEDNESDAY";
  DayOfWeek[DayOfWeek["THURSDAY"] = 4] = "THURSDAY";
  DayOfWeek[DayOfWeek["FRIDAY"] = 5] = "FRIDAY";
  DayOfWeek[DayOfWeek["SATURDAY"] = 6] = "SATURDAY";
})(DayOfWeek || (exports.DayOfWeek = DayOfWeek = {}));